module.exports = __webpack_public_path__ + "img/icon30.0bad5b74.svg";